class Fade {
  constructor() {
    this.fadeElements = document.querySelectorAll('.js-fade');
    // フェードイン発火の閾値（画面高さに対する割合）
    // 例: 0.4 = 画面上端から40%の位置に要素が入ったらフェードイン
    this.threshold = 0.4;
    this.init();
  }

  init() {
    if (!this.fadeElements.length) return;
    this.initFadeElements();
    this.initDataFadeElements();
  }

  activate(el) {
    el.classList.add('is-active');
  }

  createObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.activate(entry.target);
            // 一度発火したら監視を解除
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // 監視対象要素の上20%が画面内に入ったらトリガー
        rootMargin: '0px 0px -20% 0px',
        threshold: 0,
      }
    );
    return observer;
  }

  observeElements(elements) {
    // ページ読み込み時点でのフェードイン発火位置（px）
    // threshold = 0.4 の場合、画面上から40%の位置に要素があれば、表示させる
    const midpoint = window.innerHeight * this.threshold;
    const observer = this.createObserver();

    elements.forEach((el) => {
      // 要素上端が midpoint 以内（40%の位置を含む）の場合は即表示
      if (el.getBoundingClientRect().top <= midpoint) {
        this.activate(el);
      } else {
        observer.observe(el);
      }
    });
  }

  initFadeElements() {
    this.observeElements(this.fadeElements);
  }

  initDataFadeElements() {
    const dataFadeElements = document.querySelectorAll('.js-fade [data-fade]');
    if (!dataFadeElements.length) return;
    this.observeElements(dataFadeElements);
  }
}

export default Fade;
